import { ContactInfo } from './contactInfo';
import { User } from './user';
import { Project } from './project';
import { Item } from './item';
import { Address } from './address';

export enum BillStatus {
    New = 1,
    Paid,
    // item 555 — appended as 3 (matches backend) so existing rows keep New=1 / Paid=2. Lifecycle
    // is New (created) → Entered (accountant enters into QB) → Paid (accountant pays).
    Entered = 3,
}

export interface Bill {
    id: string;
    billNumber: string;
    // item 465 — Service Address (end-user); serviceName is the required name, rest optional
    serviceName?: string;
    serviceAddress?: Address;
    servicePhone?: string;
    serviceEmail?: string;
    date: string;
    dueDate: string;
    vendorId: string;
    customerId: string;
    projectId: string;
    internalNotes: string;
    salesRepId: string;
    discount: number;
    discountReason: string;
    costSubtotal: number;
    taxEach: number;
    costTotal: number;
    status: BillStatus;
    isArchive: boolean;
    isVoid: boolean;
    createdById: string;
    createdByName: string;
    createdDate: string;
    lastModifiedById: string;
    lastModifiedByName: string;
    lastModifiedDate: string;
    customer: ContactInfo;
    vendor: ContactInfo;
    salesRep: User;
    salesRepName: string;
    createdBy: User;
    lastModifiedBy: User;
    project: Project;
    billItems: BillItems[];
    categoryNames: string;
    isLocked: boolean;
}

export interface BillItems {
    description: string;
    costEach: number;
    retailEach: number;
    quantity: number;
    taxable: boolean;
    employeeId: string;
    id: string;
    vendorId?: string;
    brand: string;
    sku: string;
    createdById: string;
    createdDate: string;
    lastModifiedById: string;
    lastModifiedDate: string;
    vendor?: ContactInfo;
    createdBy?: User;
    lastModifiedBy?: User;
    itemId: string;
    category: string;
    costSubtotal: number;
    retailSubtotal: number;
    taxTotal: number;
    item?: Item;
    billId: string;
    costTotal: number;
    retailTotal: number;
    bill?: Bill;
    employee?: User;
    isLocked: boolean;

    // might delete
    tax: number;
}

export interface BillsDto {
    index: Bill[];
    length: number;
}
